import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import AdminSettingsPage from '../../../subsreens/gcadmin/adminsettings/AdminSettingsPage';


const AdminSettings = () => {
    return(
       <AdminMasterLayout>
        <AdminSettingsPage></AdminSettingsPage>
       </AdminMasterLayout>
    )
}

export default AdminSettings;